import { getTokenPayload } from "./lib/common/jwt";
import { tokenStorage } from "./lib/storage/token";
import { refresh } from "@/api2/.generated/user/user";
import { initializeOpenTelemetry } from "@/lib/tracing/initialize-open-telemetry";

export async function getInitialState() {
  initializeOpenTelemetry();

  const { setTokens, getTokens } = tokenStorage();

  let userInfo;

  if (process.env.NODE_ENV === "development") {
    return { userInfo: getTokenPayload(getTokens().accessToken) };
  }

  try {
    const { accessToken } = await refresh({
      withCredentials: true
    });
    setTokens({ accessToken });

    userInfo = getTokenPayload(accessToken);
  } catch {
    userInfo = null;
  }

  return { userInfo };
}
